
import { defineComponent, ref, watch, onMounted, nextTick } from 'vue'
import { mapState, useStore } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'Music',
    props: ['musicUrl'],
    computed: {
        ...mapState(['musicPaused', 'activityData'])
    },
    setup () {
        const $store = useStore()
        const isPlaying = ref<boolean>(false)
        const audioDom = ref()
        let isMb = false

        const switchMusic = (e) => {
            if (e.type === 'mousedown' && isMb) {
                return
            }
            $store.commit('SET_MUSICPAUSED', !$store.state.musicPaused)
        }

        let isTouch = false
        const firstPlay = () => {
            if (!audioDom || isTouch || !$store.state.activityData) {
                return
            }
            isTouch = true
            if (!$store.state.musicPaused) {
                audioDom.value.play()    
            }
        }

        watch(() => $store.state.activityData, (val) => {
            if (!audioDom.value) {
                return
            }
            if (val) {
                audioDom.value.play()     
            }
        })

        watch(() => $store.state.musicPaused, (val) => {
            if (!audioDom.value) {
                return
            }
            if (val) {
                audioDom.value.pause()     
            } else {
                audioDom.value.play()
            }
        })

        onMounted(() => {
            isMb = COVERAPP.Attribute.isMb()
            nextTick(() => {
                if (!audioDom.value) {
                    return
                }
                if (!$store.state.musicPaused) {
                    audioDom.value.play()
                }
            })
            // 微信自动播放
            document.addEventListener('WeixinJSBridgeReady', () => {
                if (!audioDom.value) {
                    return
                }
                if (!$store.state.musicPaused) {
                    audioDom.value.play()
                }
                if (!$store.state.activityData) {
                    setTimeout(() => {
                        audioDom.value.pause()
                    }, 0)
                }
            }, false)
            // 兼容其他不自动播放的情况
            document.addEventListener('touchstart', firstPlay, false)
            document.addEventListener('touchend',firstPlay, false)
            document.addEventListener('mousedown', firstPlay, false)
        })

        return {
            isPlaying,
            audioDom,
            switchMusic
        }
    }
})
